//兼容ie(es6转es5)
import 'babel-polyfill'
if (Number.parseInt === undefined) Number.parseInt = window.parseInt
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat
//axios兼容ie9
import promise from 'es6-promise'
promise.polyfill()
import {formatMoney,formatNumber} from './server/utils'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import config from './config/index.js'

Vue.use(Vuex)
Vue.config.productionTip = false

//自定义js
import './server/switch-type.js'
import './server/filter.js'
import './server/methods.js'

//store
import store from './vuex/store'

//axios
import http from './http'
Vue.prototype.$http = http
Vue.prototype.formatMoney = formatMoney




//element
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUi)

//打印插件
import Print from '@/js/vuePlugs_printjs-master/print'
Vue.use(Print)

//富文本编辑器 vue-quill-editor 和 vue-html5-editor(https://www.npmjs.com/package/vue-html5-editor)

//echarts模块(https://github.com/ecomfe/vue-echarts/blob/master/README.zh_CN.md)
import 'vue-echarts/node_modules/echarts/lib/component/tooltip'
import 'vue-echarts/node_modules/echarts/lib/chart/tree'
import 'vue-echarts/node_modules/echarts/lib/chart/bar'
import 'vue-echarts/node_modules/echarts/lib/chart/line'
import 'vue-echarts/node_modules/echarts/lib/chart/lines'
import 'vue-echarts/node_modules/echarts/lib/chart/pie'
import 'vue-echarts/node_modules/echarts/lib/chart/map'
import 'vue-echarts/node_modules/echarts/lib/chart/radar'
import 'vue-echarts/node_modules/echarts/lib/chart/scatter'
import 'vue-echarts/node_modules/echarts/lib/chart/effectScatter'
import 'vue-echarts/node_modules/echarts/lib/component/polar'
import 'vue-echarts/node_modules/echarts/lib/component/geo'
import 'vue-echarts/node_modules/echarts/lib/component/legend'
import 'vue-echarts/node_modules/echarts/lib/component/title'
import 'vue-echarts/node_modules/echarts/lib/component/visualMap'

//全局组件
import '@/components'

//全局按钮接口
global.buttonsUrl = '/userm/sysm/pubselect/findButtonQx'

// global.downUrl = 'http://59.173.183.231:9180/file/download/file?filePath=';//文件导出
// global.downFileUrl = 'http://59.173.183.231:9180/file/download/templet?filePath=';//文件下载
// global.fileUrl = 'http://59.173.183.231:9180/file/image/';//文件加载
// global.upUrl = 'http://59.173.183.231:9180';//文件上传

//online
// global.sysmUrl = 'http://59.173.183.231:9180';//系统设置
// global.btsmUrl = 'http://59.173.183.231:9180';//竞价
// global.fundmUrl = 'http://59.173.183.231:9180';//资金平台
// global.exmUrl = 'http://59.173.183.231:9180';//挂牌
// global.jxmUrl = 'http://59.173.183.231:9180';//竞价管理
// global.ecmUrl = 'http://59.173.183.231:9180';//挂牌管理
// global.jcmUrl = 'http://59.173.183.231:9180';//竞采管理
// global.esmUrl = 'http://59.173.183.231:9180';//采购管理

//test
// global.sysmUrl = 'http://192.168.0.183:8012';//系统设置
// global.btsmUrl = 'http://192.168.0.183:8032';//竞价
// global.fundmUrl = 'http://192.168.0.183:8022';//资金平台
// global.exmUrl = 'http://192.168.0.183:8042';//挂牌
// global.jxmUrl = 'http://192.168.0.183:8052';//竞价管理
// global.ecmUrl = 'http://192.168.0.183:8062';//挂牌管理
// global.jcmUrl = 'http://192.168.0.183:8072';//竞采管理
// global.esmUrl = 'http://192.168.0.183:8092';//采购管理

//路由守卫
// router.beforeEach(function (to,from,next) {
//   if(to.path === '/login'){
//     return next()
//   }
//   next()
// })

const env =  process.env.NODE_ENV 
console.log('env',env)
console.log('config',config.upUrl)
// Vue.prototype.$http.get('./static/config.json').then(res => {
  //online
  // global.upUrl = res.data.upUrl //文件上传
  // global.downUrl = global.upUrl + '/file/download/file?filePath=' //文件导出
  // global.downFileUrl = global.upUrl + '/file/download/templet?filePath=' //文件下载
  // global.fileUrl = global.upUrl + '/file/image/' //文件加载
  // global.sysmUrl = res.data.sysmUrl //系统设置
  // global.btsmUrl = res.data.btsmUrl //竞价
  // global.fundmUrl = res.data.fundmUrl //资金平台
  // global.exmUrl = res.data.exmUrl //挂牌
  // global.jxmUrl = res.data.jxmUrl //竞价管理
  // global.ecmUrl = res.data.ecmUrl //挂牌管理
  // global.jcmUrl = res.data.jcmUrl //竞采管理
  // global.esmUrl = res.data.esmUrl //采购管理
  // global.emmUrl = res.data.emmUrl //询价采购管理
  // global.promUrl = res.data.promUrl

  global.upUrl = config.upUrl //文件上传
  global.downUrl = config.upUrl + '/file/download/file?filePath=' //文件导出
  global.downFileUrl = config.upUrl + '/file/download/templet?filePath=' //文件下载
  global.fileUrl = config.upUrl + '/file/image/' //文件加载
  global.sysmUrl = config.sysmUrl //系统设置
  global.btsmUrl = config.btsmUrl //竞价
  global.fundmUrl = config.fundmUrl //资金平台
  global.exmUrl = config.exmUrl //挂牌
  global.jxmUrl = config.jxmUrl //竞价管理
  global.ecmUrl = config.ecmUrl //挂牌管理
  global.jcmUrl = config.jcmUrl //竞采管理
  global.esmUrl = config.esmUrl //采购管理
  global.emmUrl = config.emmUrl //询价采购管理
  global.promUrl = config.promUrl
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
  })
// })



// WEBPACK FOOTER //
// ./src/main.js